import { render, staticRenderFns } from "./Notificacion.vue?vue&type=template&id=0377e01e"
import script from "./Notificacion.vue?vue&type=script&lang=js"
export * from "./Notificacion.vue?vue&type=script&lang=js"
import style0 from "./Notificacion.vue?vue&type=style&index=0&id=0377e01e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports